import React, { useState } from 'react';
import RightMenu from './RightMenu/RightMenu';
import { Drawer, Button, Typography } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import './NavBar.css';

const { Title } = Typography;

function NavBar() {
  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <nav
      className='menu'
      style={{ position: 'fixed', zIndex: 5, width: '100%' }}
    >
      <div className='menu__logo'>
        <a href='/'>
          <img
            style={{ width: '60px' }}
            src={`https://res.cloudinary.com/${process.env.REACT_APP_CLOUD_NAME}/image/upload/v1622547918/icon/zzal_tl6ooy.png`}
            alt='logo'
          />
        </a>
      </div>
      <div className='menu__title'>
        <Title level={2}>짤해!!</Title>
      </div>
      <div className='menu__container'>
        <Button
          className='menu__mobile-button'
          type='primary'
          onClick={showDrawer}
        >
          <MenuOutlined />
        </Button>
        <Drawer
          title='메뉴'
          placement='right'
          className='menu_drawer'
          closable={false}
          onClose={onClose}
          visible={visible}
        >
          <RightMenu mode='inline' />
        </Drawer>
      </div>
    </nav>
  );
}

export default NavBar;
